import { render, staticRenderFns } from "./ContentItem.vue?vue&type=template&id=80e53a60&scoped=true"
import script from "./ContentItem.vue?vue&type=script&lang=js"
export * from "./ContentItem.vue?vue&type=script&lang=js"
import style0 from "./ContentItem.vue?vue&type=style&index=0&id=80e53a60&prod&lang=css"
import style1 from "./ContentItem.vue?vue&type=style&index=1&id=80e53a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e53a60",
  null
  
)

export default component.exports